export const wrapper = {
	display: 'flex',
};

export const colorBlock = (bgColor: string) => ({
	width: '84px',
	height: '10px',
	backgroundColor: bgColor,
	margin: '1rem 0',
});
